import { RotateCcw } from "lucide-react";

export function LoadState({ loading, error, onRetry, testid = "load-state" }) {
  if (error) {
    return (
      <div className="text-center py-12" data-testid={`${testid}-error`}>
        <p className="text-sm text-zinc-400 mb-3">Couldn't load this right now. Check your connection.</p>
        <button onClick={onRetry} data-testid={`${testid}-retry`}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 hover:bg-white/10 text-xs text-white">
          <RotateCcw className="w-3.5 h-3.5" /> Retry
        </button>
      </div>
    );
  }
  if (loading) return <div className="text-center text-zinc-500 text-sm py-10" data-testid={`${testid}-loading`}>Loading…</div>;
  return null;
}

export function ListSentinel({ hasMore, sentinelRef }) {
  if (!hasMore) return null;
  return <div ref={sentinelRef} className="h-10" data-testid="list-load-more" />;
}
